/**
 * GA4 events for the PDP size guide and customer photos (UGC).
 *
 *   size_guide_open   the "See size guide" link was clicked
 *   ugc_available     the product has customer photos, so the gallery got its
 *                     UGC button (once per page view, with ugc_photo_count)
 *   ugc_strip_view    the mobile photo strip was at least half visible for one
 *                     second (once per page view; on desktop the strip is
 *                     hidden, so it never fires there)
 *   ugc_open          customer photos were opened, ugc_source says from where:
 *                     'gallery_button' (the toggle over the gallery) or
 *                     'strip' (a strip photo, with photo_index from 1)
 *
 * Every event carries product_sku. Comparing purchase rates in GA4:
 *   UGC: sessions with ugc_open vs sessions with ugc_available and no ugc_open.
 *   Size guide: sessions with size_guide_open vs product page sessions without.
 *
 * The strip (snippets/pdp-ugc-strip.liquid) announces whether it found photos
 * with `pdp-ugc-strip:done`; ugc-gallery-toggle.js adds the gallery button on
 * that same verdict, so ugc_available matches the button being there.
 */
(function () {
  'use strict';

  var VIEW_THRESHOLD = 0.5;
  var VIEW_DWELL_MS = 1000;

  function send(name, params) {
    if (typeof gtag !== 'function') return;
    gtag('event', name, params);
  }

  function stripSku() {
    var strip = document.querySelector('[data-pdp-ugc-strip]');
    return strip ? strip.dataset.productId : undefined;
  }

  function watchStripView(strip, params) {
    if (!('IntersectionObserver' in window)) return;
    var timer = null;
    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          timer = setTimeout(function () {
            observer.disconnect();
            send('ugc_strip_view', params);
          }, VIEW_DWELL_MS);
        } else {
          clearTimeout(timer);
        }
      },
      { threshold: VIEW_THRESHOLD }
    );
    observer.observe(strip);
  }

  function onStripDone(strip) {
    if (strip.dataset.analyticsBound) return;
    strip.dataset.analyticsBound = 'true';

    var count = (strip.ugcPosts || []).length;
    if (!count) return;

    var params = { product_sku: strip.dataset.productId, ugc_photo_count: count };
    send('ugc_available', params);
    watchStripView(strip, params);
  }

  function initStrip(strip) {
    if (strip.dataset.ugcState) {
      onStripDone(strip);
    } else {
      strip.addEventListener('pdp-ugc-strip:done', function () {
        onStripDone(strip);
      }, { once: true });
    }
  }

  // Capture phase: the theme's modal and the gallery toggle handle these
  // clicks themselves and may stop them before they bubble up.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target.closest) return;

      var sizeGuide = target.closest('.pdp-size-guide__link');
      if (sizeGuide) {
        var wrapper = sizeGuide.closest('[data-product-sku]');
        send('size_guide_open', { product_sku: wrapper ? wrapper.dataset.productSku : undefined });
        return;
      }

      if (target.closest('[data-ugc-tabs] [data-ugc-target="ugc"]')) {
        send('ugc_open', { product_sku: stripSku(), ugc_source: 'gallery_button' });
        return;
      }

      var tile = target.closest('[data-pdp-ugc-strip] .pdp-ugc-strip__tile[data-index]');
      if (tile) {
        send('ugc_open', {
          product_sku: stripSku(),
          ugc_source: 'strip',
          photo_index: Number(tile.getAttribute('data-index')) + 1
        });
      }
    },
    true
  );

  function init() {
    document.querySelectorAll('[data-pdp-ugc-strip]').forEach(initStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
